import React, { useEffect, useState } from 'react'
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
  } from "../../component/ui/dropdown-menu"
import { Input } from '../ui/input'
import { Button } from '../ui/button'
import { Field,Form } from 'react-final-form'

import { composeValidators, renderField, required } from "../../helpers/form-validations"
import { meta } from 'eslint-plugin-prettier'
import { IoIosArrowBack, IoIosArrowDown } from 'react-icons/io'
import { createTickerForScheme } from '../../utils/util'
import { useDispatch, useSelector } from 'react-redux'
import AdvancedDropdown from '../ui/multi-selection-dropdown-menu-with-search'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { loaderSet } from '../../context/actions/loaderAction'
import { nullSchemeInfo } from '../../context/actions/schemeInfoAction'
import { alertDanger, alertSuccess } from '../../context/actions/toastAction'
import Loader from '../loader'

const AddTicker = ({back,getAllTickerDetails,forWhichUserType}) => {


  const allSchemeDetailsForDropdown = useSelector(state => state.allSchemeDetails);
  const schemeInfo=useSelector(state=>state.schemeInfo)
  const [searchParams] = useSearchParams();
    const tickerId = searchParams.get('ticker_id');
    const actionType = searchParams.get('action_type');
    const [schemeOption, setSchemeOption] = useState([]);
    const dispatch=useDispatch()
    const navigate=useNavigate()
    const [isLoading,setIsLoading]=useState(false)
    const [selectedSchemeOptions, setSelectedSchemeOptions] = useState(
      (schemeInfo && actionType === "Edit") ? [schemeInfo.scheme_name] : []
    );
 
    useEffect(()=>{
      console.log("scheme_name",schemeInfo,actionType,tickerId)
      if(selectedSchemeOptions.length>0)
{
  
    console.log("selectedSchemeOptions, setSelectedSchemeOptions",selectedSchemeOptions)
 }     },[])
    
    // Update schemeOption whenever allSchemeDetailsForDropdown changes
    useEffect(() => {
      if (allSchemeDetailsForDropdown && allSchemeDetailsForDropdown.length > 0) {
        const schemeNames = allSchemeDetailsForDropdown.map((scheme) => scheme.scheme_name);
        setSchemeOption(schemeNames);
      }
    }, [allSchemeDetailsForDropdown]);

    const onSubmit=async(values)=>{
      setIsLoading(true)
      const payload={
        // scheme_id:allSchemeDetailsForDropdown && allSchemeDetailsForDropdown.filter((scheme,index)=>scheme.scheme_name===selectedSchemeOptions[0]).map(scheme=>scheme.scheme_id)[0],
        scheme_name:selectedSchemeOptions[0],
        ticker_message: values.tickerMessage || schemeInfo?.ticker_message,
        ticker_name: values.tickerName || schemeInfo?.ticker_name, // Use initial value if input is empty
        isticker:schemeInfo?.ticker_name || false,
        ticker_id:actionType==="Edit" && tickerId
      }
           try {
            const response=await createTickerForScheme(payload)
            console.log("response add ticker",response)
            if(response){
              dispatch(alertSuccess(response?.message))
              getAllTickerDetails()
              setIsLoading(false)
            }
            if(actionType!=="Edit"){
              back()
              setIsLoading(false)
            }
            if(forWhichUserType==="employee"){
              navigate("/employee")
              setIsLoading(false)
            }
            if(forWhichUserType==="admin"){
              navigate("/admin")
              setIsLoading(false)
            }
            else{
              dispatch(alertDanger(response?.message))
              setIsLoading(false)
            }
           } catch (error) {
            dispatch(alertDanger("Internal Server Error"))
            console.log("Error in create ticker",error)
            setIsLoading(true)
           }
          //  finally {
          //   setTimeout(() => dispatch(loaderSet(false)), 1000); // Adds a slight delay
          // }
    }

  return (
    <>
      {
        isLoading && <Loader/>
      }
          <Form
          onSubmit={onSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>



<div className="w-full flex flex-col p-6  bg-[#FFFFFF] rounded-md gap-16">

<Button
        variant="outline"
        size="sm"
        className=" h-10  gap-1 text-sm w-max self-start "
        onClick={()=>{
          
          // dispatch(loaderSet(true))
          if(actionType!=="Edit"&& actionType!=="View")
          {

            back()
          }
          dispatch(nullSchemeInfo())
          if(forWhichUserType==="employee"){
            navigate("/employee")
          }
          if(forWhichUserType==="admin"){
            navigate("/admin")
          }
        }
        } 
      >
        <IoIosArrowBack />
        Back
      </Button> 
<div className="flex w-full justify-between items-center gap-4">
  {/* Ticker name Input field */}
  <div className="flex-1 h-10">
    <Field
    actionType={actionType}
    info={schemeInfo && schemeInfo?.ticker_name}
      id="tickerName"
      type="text"
      name="tickerName"
      placeholder="Ticker Name"
      component={renderField}
      className="bg-muted/40 h-full w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
    />
    {meta.touched && meta.error && (
      <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
    )}
  </div>

  {/* Dropdown Menu */}
  <div className="flex-1 h-10">
    <AdvancedDropdown
      name="Scheme"
      id="scheme"
      options={schemeOption}
      selectedOptions={selectedSchemeOptions}
      setSelectedOptions={setSelectedSchemeOptions}
      placeholder="Scheme"
      select="single"
      label={false}
     disabled={actionType==="Edit"}
    />
  </div>
</div>




    
  <div className="border-[#3a5dd1]">
  <Field
  actionType={actionType}
  info={schemeInfo && schemeInfo.ticker_message}
    id="tickerMessage"
    type="textarea"
    name="tickerMessage"
    placeholder="Ticker Message"
    validate={ actionType!=="View" && actionType!=="Edit" && composeValidators(required)}
    component={renderField}
    className="bg-muted/40 h-52 w-full rounded-md text-base border p-2 border-[#3a5dd1] manrope-fontCss placeholder:text-center placeholder:p-5 focus:outline-none"
  />


    {/* <textarea name="tickerMessage" id="tickerMessage" className=' bg-muted/40 rounded-base text-base border-[#3a5dd1] manrope-fontCss ' ></textarea> */}
  </div>

  <Button type="submit" className="w-[40%] bg-[#0D215C] self-end " >
                      {actionType==="Edit"? "Save Changes" : "Add Ticker"}
                    </Button>
</div>

            </form>
          )}
        />
    </>
  )
}

export default AddTicker